import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser } from "@fortawesome/free-solid-svg-icons";

import { setLoading } from "../../../../../redux/Loading/actions";
import { getAbogados } from "../../../../../redux/Sections/Abogados/actions";
import { grupoEtapasService } from "../../../../../_services/grupoEtapas.service";
import { tipoEtapasService } from "../../../../../_services/tipoEtapas.service";
import { showTable } from "../../../../../redux/Sections/Inmuebles/actions";
import { useUser } from "../../../../../hooks/useUser";
import { situacionesService } from "../../../../../_services/situaciones.service";
import Select from "../../../../../components/Select";

const emptyOption = { value: "", label: "Seleccionar..." };

export const Filter = ({ action, reference, showFilter, setShowFilter, setShowTable, section }) => {
  const { abogadosList } = useSelector(e => e.dashboard);
  const dispatch = useDispatch();
  const user = useUser();

  const {
    register,
    control,
    setValue,
    handleSubmit,
    reset
  } = useForm({});

  const [tags, setTags] = useState({});

  const [grupos, setGrupos] = useState([]);
  const [grupo, setGrupo] = useState();
  const [situaciones, setSituaciones] = useState([]);
  const [situacion, setSituacion] = useState("");
  const [tipos, setTipos] = useState([]);
  const [tipo, setTipo] = useState("");
  const [abogado, setAbogado] = useState("");

  useEffect(() => {
    const getData = () => {
      dispatch(getAbogados());
    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      let response = await grupoEtapasService.getGrupoEtapas();

      if (response?.length) {
        setGrupos(response.map(e => {
          return {
            ...e,
            value: e.id,
            label: e.nombre
          };
        }));
      }

    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      if (grupo && grupo.id) {
        dispatch(setLoading(true));

        let response = await tipoEtapasService.getTipoEtapas(grupo.id);

        if (response?.length) {
          setTipos(response.map(e => {
            return {
              ...e,
              value: e.tipo,
              label: e.nombre
            };
          }));

          dispatch(setLoading(false));
        }
        else {
          dispatch(setLoading(false));
        }
      }
      else {
        setTipos([]);
      }
    };

    getData();
  }, [grupo]);

  useEffect(() => {
    const getData = async () => {
      dispatch(setLoading(true));

      let response = await situacionesService.getSituaciones();

      if (response?.length) {
        setSituaciones(response.map(e => {
          return {
            ...e,
            value: e.CODIGO,
            label: e.DETALLE_SITUACION
          };
        }));

        dispatch(setLoading(false));
      }
      else {
        dispatch(setLoading(false));
      }
    };

    getData();
  }, []);

  const handleChange = (e) => {
    if (e) {
      setTipo("");
      setValue("estado", "");
      setGrupo(e);
    }
    else {
      setGrupo("");
    }
  };

  const handleClean = () => {
    reset({});
    setTags({});
    setGrupo({});
    setSituacion({});
    setTipo({});
    setAbogado({});
  };

  const onSubmit = async (data) => {
    for (const value in data) {
      if (!data[value]) {
        delete data[value];
      }
    }

    if (data.nombre) {
      data.nombre = data.nombre.toUpperCase();
    }

    if (Object.keys(data).length === 1 && data.situacion) {
      return Swal.fire({
        title: "No es posible buscar solo por 'estados'.",
        icon: "warning"
      }
      );
    }

    setTags(data);

    if (user.rol === "user") {
      data.abogado = user.abogado;
    }

    if (section === "contribuyentes") {
      data.nro_imponible = data.inmueble;
      delete data.inmueble;
    }

    action(data);

    setShowFilter(false);
    if (setShowTable) {
      setShowTable(true);
    }
    dispatch(showTable());
  };


  return (
    <div className="filter-container" >
      {showFilter ? (
        <Form onSubmit={handleSubmit(onSubmit)} >
          <Row>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Contribuyente</Form.Label>
              <Form.Control
                name="nombre"
                {...register("nombre")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">N° imponible</Form.Label>
              <Form.Control
                name="inmueble"
                {...register("inmueble")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Recurso</Form.Label>
              <Form.Control
                name="recurso"
                {...register("recurso")}
              />
            </Col>
          </Row>
          <Row >
            {user?.rol === "admin" ? (
              <Col sm={12} md={4} className="mt-3">
                <Form.Label className="mb-2">Abogado</Form.Label>
                <Controller
                  name="abogado"
                  control={control}
                  render={({ field: { onChange } }) => {
                    let options = abogadosList?.length ? abogadosList.map(e => {
                      return {
                        ...e,
                        value: e.codexterno,
                        label: `${e.apellido} ${e.nombre}`
                      };
                    }) : [];

                    return (
                      <Select
                        options={options?.length ? [emptyOption, ...options] : [emptyOption]}
                        onChange={(e) => {
                          setAbogado(e);
                          return onChange(e.value);
                        }}
                        value={abogado}
                      />
                    );
                  }}
                />
              </Col>
            ) : null}

            {section === "inmuebles" ? (
              <Col sm={12} md={4} className="mt-3">
                <Form.Label className="mb-2">Estados</Form.Label>
                <Controller
                  name="situacion"
                  control={control}
                  render={({ field: { onChange } }) => {
                    return (
                      <Select
                        options={situaciones?.length ? [emptyOption, ...situaciones] : [emptyOption]}
                        value={situacion}
                        onChange={(e) => {
                          setSituacion(e);
                          return onChange(e?.value);
                        }}
                      />
                    );
                  }}
                />
              </Col>
            ) :
              <>
                <Col sm={12} md={4} className="mt-3">
                  <Form.Label className="mb-2">Estado</Form.Label>
                  <Controller
                    name="gp_estado"
                    control={control}
                    render={({ field: { onChange } }) => {
                      return (
                        <Select
                          options={grupos?.length ? [emptyOption, ...grupos] : [emptyOption]}
                          value={grupo}
                          onChange={(e) => {
                            handleChange(e);
                            return onChange(e?.value);
                          }}
                        />
                      );
                    }}
                  />
                </Col>
                {grupo?.value ? (
                  <Col sm={12} md={4} className="mt-3">
                    <Form.Label style={{ margin: 11.5 }}></Form.Label>
                    <Controller
                      name="estado"
                      control={control}
                      render={({ field: { onChange } }) => {
                        return (
                          <Select
                            options={tipos?.length ? [emptyOption, ...tipos] : [emptyOption]}
                            value={tipo}
                            onChange={(e) => {
                              setTipo(e);
                              return onChange(e?.value);
                            }}
                          />
                        );
                      }}
                    />
                    <input
                      className="input-required"
                      onChange={() => ""}
                      value={tipo ? tipo : ""}
                      required
                    />
                  </Col>
                ) : ""}
              </>}
          </Row>
          <Row>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Barrio</Form.Label>
              <Form.Control
                name="barrio"
                {...register("barrio")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Calle</Form.Label>
              <Form.Control
                name="calle"
                {...register("calle")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Altura</Form.Label>
              <Form.Control
                name="altura"
                {...register("altura")}
              />
            </Col>
          </Row>

          {section === "contribuyentes" ? (
            <Row>
              <Col sm={12} md={4} className="mt-3">
                <Form.Label className="mb-2">DNI</Form.Label>
                <Form.Control
                  name="dni"
                  {...register("dni")}
                />
              </Col>
              <Col sm={12} md={4} className="mt-3">
                <Form.Label className="mb-2">CUIM</Form.Label>
                <Form.Control
                  name="cuim"
                  {...register("cuim")}
                />
              </Col>
            </Row>
          ) : null}

          {section === "inmuebles" ? (
            <>
              <Row>
                <Col sm={12} md={4} className="mt-3">
                  <Form.Label className="mb-2">Partida Inmobiliaria</Form.Label>
                  <Form.Control
                    name="partida"
                    {...register("partida")}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Circ</Form.Label>
                  <Form.Control
                    name="circ"
                    {...register("circ")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Secc</Form.Label>
                  <Form.Control
                    name="secc"
                    {...register("secc")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Ch Nro</Form.Label>
                  <Form.Control
                    name="chN"
                    {...register("chN")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Ch Lta</Form.Label>
                  <Form.Control
                    name="chL"
                    {...register("chL")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Qt Nro</Form.Label>
                  <Form.Control
                    name="qtN"
                    {...register("qtN")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Qt Lta</Form.Label>
                  <Form.Control
                    name="qtL"
                    {...register("qtL")}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Fr Nro</Form.Label>
                  <Form.Control
                    name="frN"
                    {...register("frN")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Fr Lta</Form.Label>
                  <Form.Control
                    name="frL"
                    {...register("frL")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Mz Nro</Form.Label>
                  <Form.Control
                    name="mzN"
                    {...register("mzN")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Mz Lta</Form.Label>
                  <Form.Control
                    name="mzL"
                    {...register("mzL")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Pc Nro</Form.Label>
                  <Form.Control
                    name="pcN"
                    {...register("pcN")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Pc Lta</Form.Label>
                  <Form.Control
                    name="pcL"
                    {...register("pcL")}
                  />
                </Col>
              </Row>

              <Row className="mt-3">
                <Col className="col-auto" sm={12} md={4}>
                  <Form.Label className="my-2">Sub Pc</Form.Label>
                  <Form.Control
                    name="sbPc"
                    {...register("sbPc")}
                  />
                </Col>
              </Row>
            </>
          ) : null}

          <Row className=" d-flex justify-content-end" >
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="button"
                variant="danger"
                onClick={handleClean}
                className="danger-button d-flex align-items-center"
              >
                <FontAwesomeIcon icon={faEraser} size="1x" /><span className="ml-2">LIMPIAR</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="submit"
                ref={reference}
                className="custom-button"
              >
                BUSCAR
              </Button>
            </Col>
          </Row>
        </Form>
      ) : null}
      <>
        {
          <Row className="d-flex justify-content-start mt-4" style={{ paddingLeft: 15 }}>
            <div className="filterby">
              <h5 style={{ marginTop: "2px", fontWeight: 700 }} >Filtrado por:</h5>
            </div>
            {!Object.values(tags).filter((e) => e !== "").length && (
              <div className="tags">
                <span
                  key="sinopciones"
                >
                  No hay opciones seleccionadas
                </span>
              </div>
            )}

            {tags?.nombre &&
              <div className="tags">
                <span key="nombre" >
                  Nombre : {tags.nombre}
                </span>
              </div>}

            {tags?.inmueble &&
              <div className="tags">
                <span key="nro_imponible" >
                  Número Imponible : {tags.inmueble}
                </span>
              </div>}

            {tags.domicilio &&
              <div className="tags">
                <span key="domicilio" >
                  Domicilio : {tags.domicilio}
                </span>
              </div>}

            {tags.barrio &&
              <div className="tags">
                <span key="barrio" >
                  Barrio : {tags.barrio}
                </span>
              </div>}

            {tags.recurso &&
              <div className="tags">
                <span key="recurso" >
                  Recurso : {tags.recurso}
                </span>
              </div>}

            {tags.abogado &&
              <div className="tags">
                <span key="abogado" >
                  Abogado : {tags.abogado}
                </span>
              </div>}


            {tags.estado &&
              <div className="tags">
                <span key="partidaInmobiliaria" >
                  Grupo : {grupo?.nombre}
                </span>
              </div>}

            {tags.estado &&
              <div className="tags">
                <span key="estado" >
                  Estado : {tipo?.nombre}
                </span>
              </div>}

            {tags.situacion &&
              <div className="tags">
                <span key="situacion" >
                  Estado : {situacion?.label}
                </span>
              </div>}

            {tags.calle &&
              <div className="tags">
                <span key="calle" >
                  Calle: {tags.calle}
                </span>
              </div>}

            {tags.altura &&
              <div className="tags">
                <span key="altura" >
                  Altura : {tags.altura}
                </span>
              </div>}

            {tags.partida &&
              <div className="tags">
                <span key="partidaInmobiliaria" >
                  Partida Inmobiliaria : {tags.partida}
                </span>
              </div>}

            {tags?.circ && (
              <div className="tags">
                <span color="green" key="circ">
                  Circ : {tags?.circ}
                </span>
              </div>
            )}

            {tags?.secc && (
              <div className="tags">
                <span color="green" key="partidaInmobiliaria">
                  Secc : {tags?.secc}
                </span>
              </div>
            )}

            {tags?.chN && (
              <div className="tags">
                <span color="green" key="chN">
                  Ch Nro : {tags?.chN}
                </span>
              </div>
            )}

            {tags?.chL && (
              <div className="tags">
                <span color="green" key="chL">
                  Ch Lta : {tags?.chL}
                </span>
              </div>
            )}

            {tags?.qtN && (
              <div className="tags">
                <span color="green" key="qtN">
                  Qt Nro : {tags?.qtN}
                </span>
              </div>
            )}

            {tags?.qtL && (
              <div className="tags">
                <span color="green" key="qtL">
                  Qt Lta : {tags?.qtL}
                </span>
              </div>
            )}

            {tags?.frN && (
              <div className="tags">
                <span color="green" key="frN">
                  Fr Nro : {tags?.frN}
                </span>
              </div>
            )}

            {tags?.frL && (
              <div className="tags">
                <span color="green" key="frL">
                  Fr Lta : {tags?.frL}
                </span>
              </div>
            )}

            {tags?.mzN && (
              <div className="tags">
                <span color="green" key="mzN">
                  Mz Nro : {tags?.mzN}
                </span>
              </div>
            )}

            {tags?.mzL && (
              <div className="tags">
                <span color="green" key="mzL">
                  Mz Lta : {tags?.mzL}
                </span>
              </div>
            )}

            {tags?.pcN && (
              <div className="tags">
                <span color="green" key="pcN">
                  Pc Nro : {tags?.pcN}
                </span>
              </div>
            )}

            {tags?.pcL && (
              <div className="tags">
                <span color="green" key="pcL">
                  Pc Lta : {tags?.pcL}
                </span>
              </div>
            )}

            {tags?.sbPc && (
              <div className="tags">
                <span color="green" key="sbPc">
                  Sub Pc : {tags?.sbPc}
                </span>
              </div>
            )}

            {tags?.dni && (
              <div className="tags">
                <span color="green" key="dni">
                  DNI : {tags?.dni}
                </span>
              </div>
            )}

            {tags?.cuim && (
              <div className="tags">
                <span color="green" key="cuim">
                  CUIM : {tags?.cuim}
                </span>
              </div>
            )}
          </Row>
        }
      </>
    </div>
  );
};
